// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import ElementUI from 'element-ui';
import vueCk from 'vue-cookie';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App'
import router from './router'


Vue.use(ElementUI);
Vue.use(vueCk);
Vue.config.productionTip = false

router.beforeEach((to, from, next) => {
  if (to.path != "/login") {
    if (localStorage.getItem('access_token')) {
        next();
    } else {
      console.log(2233)
      console.log(to.path)
      if (to.path == "/complete") {
        next();
      }else{
        next('/login')
      }
    }
  }else{
    next();
  }
});
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js